// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__3nsAV","header":"MessagesList_header__2mz9-","chat":"MessagesList_chat__1Z22R"};